import { authHeader, handleResponse } from '../_helpers';
import { config } from "../../common/constant";
import { getPaymentEndpoint } from '../../common';
import { captureApiError } from '../../common';

export const tokenServices = {
    getToken
};

async function getToken(payload) {
    const version = getPaymentEndpoint();
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(payload)
    };
     const url = config.BASE_URL_DOMAIN + `/payment-${version}/api/Donation/getTokenID`;
    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(result => {
            if (result.data !== null && result.data !== undefined && result.data.status === 1) {
                return result.data;
            } else {
                return false
            }
        }).catch(error => {
            captureApiError(error)
            return false;
        });
}